document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const cartCountNodes = document.querySelectorAll('[data-cart-count]');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const setMotionTargets = (selector, effect, stagger = 0, baseDelay = 0) => {
    document.querySelectorAll(selector).forEach((element, index) => {
      if (!element.dataset.motion) {
        element.dataset.motion = effect;
      }

      if (!element.style.getPropertyValue('--jj-motion-delay')) {
        const delay = baseDelay + index * stagger;
        if (delay > 0) {
          element.style.setProperty('--jj-motion-delay', `${delay}ms`);
        }
      }
    });
  };

  const setupMotion = () => {
    const motionGroups = [
      ['.jj-hero__content', 'slide-in-left'],
      ['.jj-craft__image', 'fade-in'],
      ['.jj-craft__copy', 'slide-in-right'],
      ['.jj-testimonials .jj-heading--section', 'fade-in'],
      ['.jj-testimonials__grid', 'bounce-in'],
      ['.jj-gallery .jj-heading--section', 'fade-in'],
      ['.jj-story__panel', 'slide-in-up'],
      ['.jj-instagram .jj-heading--section', 'fade-in'],
      ['.jj-instagram__actions', 'fade-in', 0, 180],
      ['.jj-contact__panel--left', 'fade-in'],
      ['.jj-contact__social-list', 'fade-in', 0, 200],
      ['.jj-contact__panel:not(.jj-contact__panel--left)', 'pulse'],
      ['.jj-product-grid-section__header', 'fade-in-up'],
      ['.jj-page-header', 'fade-in-up'],
      ['.jj-page-content', 'fade-in-up', 0, 120],
      ['.jj-hechsher__title', 'fade-in'],
      ['.jj-hechsher__grid > :first-child', 'fade-in-up'],
      ['.jj-hechsher__grid > :last-child', 'fade-in', 0, 120],
      ['.jj-catalog__inner > .jj-page-frame__title', 'fade-in-up'],
      ['.jj-promo-lead', 'fade-in-up', 0, 100],
      ['.jj-catalog__wholesale', 'fade-in', 0, 160],
      ['.jj-main-product .jj-product__gallery', 'fade-in-up'],
      ['.jj-main-product .jj-product__meta', 'slide-in-right'],
      ['.jj-main-cart .jj-cart', 'fade-in-up', 0, 120],
      ['.jj-main-cart .jj-empty', 'fade-in-up', 0, 120],
      ['.jj-main-404 .jj-page-header', 'fade-in-up'],
      ['.jj-main-404 .jj-empty', 'fade-in-up', 0, 140],
      ['.jj-footer__text', 'fade-in-up']
    ];

    motionGroups.forEach(([selector, effect, stagger, baseDelay]) => {
      setMotionTargets(selector, effect, stagger, baseDelay);
    });

    const staggeredGroups = [
      ['.jj-gallery__grid > *', 'fade-in-up', 90],
      ['.jj-instagram__grid > *', 'fade-in', 90],
      ['.jj-product-grid > *', 'fade-in-up', 90],
      ['.jj-collection-list__grid > *', 'fade-in-up', 90],
      ['.jj-catalog__grid > *', 'fade-in-up', 110],
      ['.jj-product__thumbs > *', 'fade-in', 60, 120]
    ];

    staggeredGroups.forEach(([selector, effect, stagger, baseDelay]) => {
      setMotionTargets(selector, effect, stagger, baseDelay);
    });

    const motionTargets = document.querySelectorAll('[data-motion]');
    if (!motionTargets.length) {
      return;
    }

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      motionTargets.forEach((element) => {
        element.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.16,
        rootMargin: '0px 0px -12% 0px'
      }
    );

    const isInInitialViewport = (element) => {
      const bounds = element.getBoundingClientRect();
      return bounds.top < window.innerHeight * 0.92 && bounds.bottom > 0;
    };

    motionTargets.forEach((element) => {
      if (isInInitialViewport(element)) {
        element.classList.add('is-visible');
        return;
      }

      observer.observe(element);
    });
  };

  setupMotion();

  const updateCartCount = (count) => {
    cartCountNodes.forEach((node) => {
      node.textContent = String(count);
    });
  };

  const setCardState = (button, state) => {
    const textNode = button.querySelector('[data-card-cta-text]');
    const defaultLabel = button.dataset.defaultLabel || 'Add to cart';
    const addingLabel = button.dataset.addingLabel || 'Adding...';
    const addedLabel = button.dataset.addedLabel || 'Added';

    button.classList.remove('is-loading', 'is-added');
    button.disabled = false;
    button.removeAttribute('aria-busy');

    if (state === 'loading') {
      button.classList.add('is-loading');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (textNode) {
        textNode.textContent = addingLabel;
      }
      return;
    }

    if (state === 'added') {
      button.classList.add('is-added');
      if (textNode) {
        textNode.textContent = addedLabel;
      }
      return;
    }

    if (textNode) {
      textNode.textContent = defaultLabel;
    }
  };

  document.querySelectorAll('[data-ajax-cart-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const submitButton = form.querySelector('[data-card-submit]');
      if (!submitButton || submitButton.classList.contains('is-loading')) {
        return;
      }

      setCardState(submitButton, 'loading');

      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: new FormData(form)
        });

        if (!addResponse.ok) {
          throw new Error('Cart add failed');
        }

        const cartResponse = await fetch('/cart.js', {
          headers: {
            Accept: 'application/json'
          }
        });

        if (!cartResponse.ok) {
          throw new Error('Cart fetch failed');
        }

        const cart = await cartResponse.json();
        updateCartCount(cart.item_count);
        setCardState(submitButton, 'added');

        window.setTimeout(() => {
          setCardState(submitButton, 'default');
        }, 1200);
      } catch (error) {
        setCardState(submitButton, 'default');
        console.error(error);
      }
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-product-main-image]');
    const buttons = gallery.querySelectorAll('[data-product-thumb]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const imageUrl = button.getAttribute('data-image-url');
        const imageAlt = button.getAttribute('data-image-alt') || '';

        if (!mainImage || !imageUrl) {
          return;
        }

        mainImage.src = imageUrl;
        mainImage.alt = imageAlt;

        buttons.forEach((thumb) => thumb.classList.remove('is-active'));
        button.classList.add('is-active');
      });
    });
  });
});
